import { CircularProgress, Grid, TextField, Tooltip } from "@material-ui/core"
import React from "react"
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';

const CodeInput = (props) => {

    const [digit, setDigit] = React.useState([])
    const [load, setLoad] = React.useState(false)
    const [valid, setValid] = React.useState(false)
    const [invalid, setInvalid] = React.useState(false)

    const isNum = (val) => {
        return /^-?\d+$/.test(val);
    }

    const isValid = () => {
        setLoad(false)
        setInvalid(false)
        setValid(true)
    }

    const isInvalid = () => {
        setLoad(false)
        setInvalid(true)
        setValid(false)
    }

    const isLoad = () => {
        setLoad(true)
        setInvalid(false)
        setValid(false)
    }

    const sendNumber = () => {
        let code = digit.join('')
        isLoad()
        props.validCode(code).then(() => {
            props.receiveCode({code: code, valid: true})
            isValid()
        }).catch(() => {
            props.receiveCode({code: code, valid: false})
            isInvalid()
        })
       
    }

    const inputPress = (event, input) => {
        const value = event.target.value
        const isKeyNumber = /^[0-9]$/i.test(event.key)

        if (value == null) return

        if (input + 1 <= props.quantity && isNum(value) && isKeyNumber) {
            if (input + 1 !== props.quantity) {
                document.getElementById(`input${input + 1}`).focus()
            }

            let table = digit
            table.push(value)

            setDigit(table)
        }

        if (event.key === "Backspace" && input - 1 >= 0) {
            for (let i = 0; i < props.quantity; i++) {
                document.getElementById(`input${i}`).value = null
            }
            document.getElementById(`input0`).focus()
            setDigit([])
        }

        if (input + 1 === props.quantity) {
            sendNumber()
        }
    }

    const fields = Array.from({ length: props.quantity }, (_, i) => (
        <Grid item xs>
            <TextField
                id={`input${i}`}
                variant="outlined"
                type="number"
                color="primary"
                fullWidth
                onKeyUp={(event) => { inputPress(event, i) }}
                inputProps={{
                    maxLength: 1,
                    min: 0,
                    style: {
                        textAlign: 'center',
                        fontWeight: 'bold',
                        fontSize: 28
                    },
                    inputMode: 'numeric',
                    pattern: '[0-9]*'
                }} />
        </Grid>
    ))

    return (
        <Grid container direction="row" justify="center" alignItems="center" spacing={1}>
            {fields}
            {
                valid ? <Grid item xs>
                    <Tooltip title="Código Válido">
                        <CheckCircleIcon style={{ color: 'green' }} />
                    </Tooltip>
                </Grid> : null
            }
            {
                invalid ? <Grid item xs>
                    <Tooltip title="Código Inválido">
                        <CancelIcon color="error" />
                    </Tooltip>
                </Grid> : null
            }
            {
                load ? <Grid item xs>
                    <CircularProgress size={30} />
                </Grid> : null
            }
        </Grid>
    )
}

export default CodeInput